module.exports = __webpack_public_path__ + "img/clear_ov.ee0eba6d.png";